import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// Gère le cycle de vie d'un graphique ApexCharts sur le dashboard.
// Se connecte au DOM, rend le graphique, et le détruit proprement
// avant qu'une mise à jour de Turbo ne le remplace.
export default class extends Controller {
  static targets = ["container", "data"];

  connect() {
    // Rend le graphique dès que le widget est ajouté au DOM.
    this.renderChart();
  }

  disconnect() {
    // Détruit le graphique avant que l'élément soit retiré du DOM
    // pour éviter les fuites de mémoire.
    if (this.chart) {
      this.chart.destroy();
    }
  }

  renderChart() {
    try {
      const chartData = JSON.parse(this.dataTarget.innerHTML);
      const labels = Object.keys(chartData);
      const data = Object.values(chartData).map(value => parseFloat(value));

      // Si aucune donnée, ne rien faire.
      if (data.length === 0) return;

      // Configuration ApexCharts pour un graphique en donut
      const options = {
        series: data,
        chart: {
          type: 'donut',
          height: 150,
          toolbar: {
            show: false
          }
        },
        labels: labels,
        colors: ['#3b82f6', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6'],
        legend: {
          position: 'bottom',
          fontSize: '12px'
        },
        plotOptions: {
          pie: {
            donut: {
              size: '60%'
            }
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              height: 120
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      };

      this.chart = new ApexCharts(this.containerTarget, options);
      this.chart.render();
    } catch (e) {
      console.error("Erreur lors du parsing des données du graphique :", e);
    }
  }
}
